import { Routes } from "@angular/router";

export const content: Routes = [
  {
    path: "simple-page",
    loadChildren: () => import("../../components/simple-page/simple-page.module").then((m) => m.SimplePageModule),
  },
  {
    path: "single-page",
    loadChildren: () => import("../../components/single-page/single-page.module").then((m) => m.SinglePageModule),
  },
  {
    path: "dashboard",
    loadChildren: () => import("../../views/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
 
  {
    path: "running-orders",
    loadChildren: () => import("../../views/running-orders/running-orders.module").then((m) => m.RunningOrdersModule),
  },
];
